import Services from '../../services'
import Vue from 'vue';
import {splitIdsCollection} from "../../utils/store";

const state = {
  rates: {},
  currentCreateRate: {
    criteria: [],
    locked: 0,
  },
  currentCreateRateCriteria: [],
};

// getters
const getters = {
  rate: (state) => id => state.rates[id],
  getCurrentCreateRate: (state) => state.currentCreateRate,
  getCurrentCreateRateCriteria: (state) => state.currentCreateRateCriteria,
  getCriterionEvaluation: (state) => id => state.currentCreateRate.criteria[id].evaluation,
  getCriterionJustification: (state) => id => state.currentCreateRate.criteria[id].justification,
  getAverageEvaluation: (state, getters) => {
    return state.currentCreateRateCriteria.reduce((p, c) => {
      return p + getters.getCriterionEvaluation(c);
    }, 0) / getters.getCurrentCreateRateCriteria.length;
  },
  isSelectedCriterion: (state) => id => state.currentCreateRateCriteria.includes(id),
};

// actions
const actions = {

  async fetchRate({commit, state, dispatch, rootGetters}, id) {
    if(state.rates[id]) {
      return;
    }

    const data = await Services.Rates.fetchRate(id, rootGetters['auth/token']);
    await dispatch('pushRate', data);
  },

  async pushRate({commit, state, dispatch, rootGetters}, rate) {
    // console.log(rate);

    const { ids: criteriaIds, objects: criteriaObjects } = splitIdsCollection(rate.criteria.map(c => c.criterion));

    await dispatch('assets/pushCriteria', criteriaObjects, {root: true});

    // assemble true collection of criteria
    const assembledCriteria = [];

    rate.criteria.forEach(c => {
      if(criteriaIds.includes(c.criterion)) {
        assembledCriteria.push(c);
      } else if(criteriaObjects.includes(c.criterion)) {
        assembledCriteria.push({
          criterion: c.criterion.id,
          popularity: c.popularity
        });
      }
    });

    rate.criteria = assembledCriteria;

    commit('addRate', {id: rate.id, rate});
  },

  addCriterion({commit, state, dispatch}, title) {
    
  },

  toggleCriterion({commit, state, dispatch}, id) {
    commit('toggleCriterion', id);
  },
  resetCriteria({commit, state, dispatch}) {
    commit('resetCriteria');
  },
  changeEvaluation({commit, state, dispatch}, {id, evaluation}) {
    commit('changeEvaluation', {id, evaluation})
  },
  changeJustification({commit, state, dispatch}, {id, justification}) {
    commit('changeJustification', {id, justification})
  }
};

// mutations
const mutations = {
  toggleCriterion(state, id) {
    if(state.currentCreateRateCriteria.includes(id)) {
      state.currentCreateRateCriteria.splice(state.currentCreateRateCriteria.indexOf(id), 1);
      state.currentCreateRate.criteria.splice(id, 1);
    } else {
      state.currentCreateRateCriteria.push(id);
      Vue.set(state.currentCreateRate.criteria, id, {
        evaluation: 5,
        justification: ''
      });
    }
  },
  resetCriteria(state) {
    state.currentCreateRateCriteria = [];
    state.currentCreateRate = {
      criteria: [],
      locked: 0,
    }
  },
  changeEvaluation(state, {id, evaluation}) {
    state.currentCreateRate.criteria[id].evaluation = evaluation;
  },
  changeJustification(state, {id, justification}) {
    state.currentCreateRate.criteria[id].justification = justification;
  },
  addRate(state, {rate, id}) {
    state.rates[id] = rate;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/rate.js